<template>
  <v-app-bar flat app class="custom-app-bar">
    <div class="d-flex align-center">
      <router-link to="/" class="home-link">
        <v-img
          alt="Logo"
          class="shrink mr-2"
          contain
          src="@/assets/flybysms.svg"
          transition="scale-transition"
          width="120"
        />
      </router-link>
    </div>

    <v-spacer></v-spacer>

    <v-btn class="primary white--text" plain @click="routeToHandler">
      {{ btnName }}</v-btn
    >
  </v-app-bar>
</template>

<script>
export default {
  props: ["routeTo", "btnName"],
  methods: {
    routeToHandler() {
      this.$router.push({ name: this.routeTo });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.custom-app-bar {
  border-bottom: 1px solid #ccc !important;
  background-color: white !important;
}
</style>
